import type { Scene } from '../types'

export const closingScenes: Scene[] = [
  {
    id: 'CLOSE-01',
    chapter: 'closing',
    route: '/closing',
    title: 'Final Proposition',
    headline: 'One lifecycle. One platform. One source of operational truth.',
    supporting:
      'LAMS combines SRWMD land processes, GIS context, work, documents, governance and operational history in a purpose-built platform designed to evolve with the District.',
    visual: 'closing-lifecycle',
    sourceRefs: [
      { kind: 'proposal', label: 'Merlion Proposed Solution', locator: 'Section 2' },
    ],
    presenterNotes: [
      'Close on confidence and fit. Do not end on technology or on price.',
      'The five conclusions to leave behind, in the order they were built: Merlion IT brings company leadership and a named team with architecture, GIS, land, EAM and delivery experience; the design is grounded in the EAM discipline, extended for public land; the architecture and its three products are governed and integrate with the District landscape; there is a concrete 34-week Scrum plan with milestone acceptance, risk controls and measurable outcomes; and the investment is not-to-exceed, milestone-based, accountable, and followed by twelve months of measured support.',
      'Final impression: this is not a generic package being configured around SRWMD. It is a purpose-built land operations platform, designed from the District lifecycle outward.',
      'Then stop talking and invite questions.',
    ],
    estimatedSeconds: 45,
    evalTags: ['EVAL-WP'],
  },
]
